import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AWS_KEYS } from "../../../apis/api";
import Card from "../../../component/card/Card";
import Starter from "../../../component/Starter";
import { helperFunction } from "../../../constant/helper";
import AWS from "aws-sdk";

import {
  addAndEditQuery,
  clearQueryErrors,
  clearQueryResult,
  setQueryLoading
} from "../../../redux/actions/queryActions";
import QueryInput from "./QueryInput";

const initialQueryState = {
  queryBody: "",
  queryTitle: "",
  locationId: "",
  queryStatus: "",
  platformType: "",
  querySubject: "",
  queryCategory: "",
  queryTypeStatus: ""
};

AWS.config.update({
  accessKeyId: AWS_KEYS.accessKeyId,
  secretAccessKey: AWS_KEYS.secretAccessKey
});

const myBucket = new AWS.S3({
  params: { Bucket: AWS_KEYS.s3Bucket },
  region: AWS_KEYS.s3Region
});

const AddQuery = () => {
  const dispatch = useDispatch();
  const loginType = localStorage.loginType;
  const [allLocations, setAllLocations] = useState([]);
  const [queryScreenshots, setQueryScreenshots] = useState([]);
  const [
    queryScreenshotsLoading,
    setQueryScreenshotsLoading
  ] = useState(false);
  const [queryInput, setQueryInput] = useState(initialQueryState);

  const { queryLoading, queryResponse, queryError } = useSelector(
    (state) => state.query
  );
  const { currentUser } = useSelector((state) => state.auth);
  const { locations } = useSelector((state) => state.location);

  useEffect(() => {
    if (locations !== null) {
      setAllLocations(locations);
    } else {
      setAllLocations([]);
    }
  }, [locations]);

  useEffect(() => {
    if (queryError) {
      helperFunction.toastHelper("error", queryError);
    }
    if (queryResponse) {
      helperFunction.toastHelper("success", queryResponse);
    }
  }, [queryError, queryResponse]);

  const handleInitialState = (e) => {
    const { name, value } = e.target;
    setQueryInput({
      ...queryInput,
      [name]: value
    });
  };

  const getImagesUrl = async (e) => {
    setQueryScreenshotsLoading(true);

    const { files } = e.target;
    const file = files[0];
    const totalSizeMB = files[0].size / Math.pow(1024, 2);

    if (parseFloat(totalSizeMB).toFixed(2) <= 2) {
      const params = {
        Body: file,
        Bucket: AWS_KEYS.s3Bucket,
        Key: file.name
      };

      const uploaded = await myBucket.upload(params).promise();
      const { Location } = uploaded;

      if (Location) {
        setQueryScreenshots((previous) => [...previous, Location]);
        // setQueryScreenshots(queryScreenshots.concat(Location));
        setQueryScreenshotsLoading(false);
      } else {
        setQueryScreenshotsLoading(false);
        helperFunction.toastHelper(
          "error",
          "Error While uploading file"
        );
      }
    } else {
      setQueryScreenshotsLoading(false);
      helperFunction.toastHelper(
        "error",
        "File size is more than 2MB"
      );
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const queryId = "addQuery";
    const queryData = {
      queryScreenshots,
      queryStatus: "UN-SOLVED",
      queryBody: queryInput.queryBody,
      locationId: queryInput.locationId,
      platformType: queryInput.platformType,
      querySubject: queryInput.querySubject,
      queryCategory: queryInput.queryCategory,
      queryTitle: queryInput.queryTitle.trim(),
      queryTypeStatus: queryInput.queryTypeStatus
    };
    dispatch(setQueryLoading(true));
    dispatch(clearQueryErrors());
    dispatch(clearQueryResult());
    dispatch(addAndEditQuery(queryData, queryId, loginType));
  };

  return (
    <Starter
      topBarTitle="Raise Ticket"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">Query Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">Query</a>
          </li>
          <li className="breadcrumb-item active">Raise Ticket</li>
        </Fragment>
      }
    >
      <Card>
        <QueryInput
          allLocations={
            typeof allLocations !== "undefined" &&
            allLocations.length > 0
              ? allLocations
              : []
          }
          queryInput={queryInput}
          currentUser={currentUser}
          handleSubmit={handleSubmit}
          getImagesUrl={getImagesUrl}
          queryLoading={queryLoading}
          queryScreenshots={queryScreenshots}
          handleInitialState={handleInitialState}
          queryScreenshotsLoading={queryScreenshotsLoading}
        />
      </Card>
    </Starter>
  );
};

export default AddQuery;
